import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { Subscription } from 'rxjs/Rx';

import { ShipDeliService } from '../../../service/ship-deli/ship-deli.service';
import { ShipInvoiceService } from '../../../service/ship-invoice/ship-invoice.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';
import { isAuthority } from '../../../util/util';
import * as moment from 'moment';
import { MdButtonToggleGroupBase } from '@angular/material';
import { EventManager } from '@angular/platform-browser';
import { getCreateFormRequest } from '../../../util/util';
import { CreateFormService } from '../../../service/create-form/create-form.service';
import { PollingService } from '../../../service/polling/polling.service';

declare const cwebclient:any;

@Component({
  selector: 'app-root',
  templateUrl: 'wa3051.component.html',
  styleUrls: ['wa3051.component.scss']
})
export class Wa3051Component implements OnInit, AfterViewInit {
  public componentTitle = 'WA3051:荷札出力（オーダーピック）';

  public owners: any;
  public ownerId: number;

  @ViewChild('picknoCdElement') picknoCdElement: ElementRef;
  @ViewChild('caseCdElement') caseCdElement: ElementRef;

  // ケースサイズコードのリスト
  public caseList: object[] = [];
  // ケースコードが1つでも入力されたか（出力ボタンを押せるかの判断で利用）
  public isCaseEnterd = false;
  // 再出力であるか
  public isRePrint = false;

  // 印刷設定
  private printagentCd = '';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public picknoCd = new FormControl('', [Validators.required, Validators.maxLength(validation.picknoCd.maxLength)]);
  public caseCd = new FormControl('', [Validators.required, Validators.maxLength(validation.caseCd.maxLength)]);

  // Authorith
  public disableF999 = isAuthority('wa3051', 'F999');
  private errorInfo = '';

  private tabIndex = 0;
  private isSubmitButtonEnabled = false;

  @ViewChild('logArea')
  logArea: ElementRef;

  @ViewChild('logArea2')
  logArea2: ElementRef;

  private firstInputFlag = 0;
  private secondInputFlag = 1;

  private isShowConfirmDialog = false;
  private executeButton = false;

  //ポーリング用変数
  //subject = new Subject<any>();
  data$ = new Subscription();

  //荷札出力画面はナビゲーション無効化（画面遷移防止）
  public showNavbar: boolean = false;
  public showsidemenu: boolean = false;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private shipDeliService: ShipDeliService,
    private shipInvoiceService: ShipInvoiceService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private route: ActivatedRoute,
    private eventManager: EventManager,
    private createFormService: CreateFormService,
    private pollingService: PollingService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    // 印刷設定取得
    if (localStorage.getItem(`printagentCd`) !== null) {
      this.printagentCd = localStorage.getItem(`printagentCd`);
    }

    this.picknoCd.valueChanges.subscribe(data => {
      this.onTextInputChanged();
    });

    this.caseCd.valueChanges.subscribe(data => {
      this.onTextInputChanged();
    });
    this.caseCd.disable();

    //ポーリング用サブスクライブ
    const targetReportCdList: string[] = ['RC0111','RC0112','RC0113','RC0211','RA3008'];
    this.data$ = this.pollingService.polling(this.printagentCd, targetReportCdList).subscribe(data => this.checkPrintQueueSuccess(data), data => this.checkPrintQueueError(data));

  }

  onTextInputChanged() {
    this.isSubmitButtonEnabled = this.tabIndex == 0 ? this.picknoCd.value.length > 0 && this.isCaseEnterd == true : this.picknoCd.value.length > 0;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    this.eventManager.addGlobalEventListener('window', 'keyup.enter', () => {
      if (!this.isShowConfirmDialog)
        return;
      var modal1 = document.getElementById('modal1');
      var btns = modal1.querySelectorAll('.btn_secondary_grayback');
      if (btns.length > 0) {
        var btn = btns[0];
        if (btn.classList.contains('onfocus'))
          this.isShowConfirmDialog = false;
        else
          this.onGlobalEnterKeyup();
      }
    });
    this.eventManager.addGlobalEventListener('window', 'keyup.esc', () => {
      if (!this.isShowConfirmDialog)
        return;
      this.confirmDialogCancel();
    });
    this.eventManager.addGlobalEventListener('window', 'keyup.tab', () => {
      if (!this.isShowConfirmDialog)
        return;

      var modal1 = document.getElementById('modal1');
      var btns = modal1.querySelectorAll('a');
      var isPrevOnFocus = false;
      for (var i = 0; i < btns.length; i++) {
        var btn = btns[i];
        // btns.forEach(btn => {
        if (btn.classList.contains('onfocus')) {
          btn.classList.remove('onfocus');
        }
        else {
          if (!isPrevOnFocus)
            btn.classList.add('onfocus');
          else
            btn.classList.remove('onfocus');
          isPrevOnFocus = true;
        }
      }
    });
  }

  //ポーリングデータ削除
  ngOnDestroy(){
    if(this.data$){
      this.data$.unsubscribe();
    }
  }

  ngAfterViewInit() {
    sessionStorage.removeItem('isShowOwnerSelect');
    sessionStorage.removeItem('showCommonHeader');
    document.getElementById('mypage').style.display = 'none';
    setTimeout(() => {
      this.picknoCdElement.nativeElement.focus();
      this.onView();
    }, 500);
  }

  onView() {
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.tabIndex = parseInt(this.route.snapshot.queryParamMap.get('tab'));
    });

    this.ownerService
      .get()
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        this.owners = outputJson.owners;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onChangePicknoCd(event: any) {
    if (event.target.value.trim() === '') {
      return;
    }
    switch (this.tabIndex) {
      case 0: {
        this.checkOrder();
        break;
      }
      case 1: {
        this.executeTab2();
        break;
      }
    }
  }

  onSelectExecuteBt(event: any) {
    this.executeButton = true;
  }

  confirmDialogCancel() {
    switch (this.tabIndex) {
      case 0: {
        this.onTabConfirmDialogCancelButtonClick();
        break;
      }
      case 1: {
        this.onTab2ConfirmDialogCancelButtonClick();
        break;
      }
    }
    this.isShowConfirmDialog = false;

    var modal1 = document.getElementById('modal1');
    var btns = modal1.querySelectorAll('.btn_modal');
    if (btns.length > 0) {
      for (var i = 0; i < btns.length; i++) {
        var btn = btns[i];
        if (btn.classList.contains('onfocus'))
          btn.classList.remove('onfocus');
      }
    }
  }
  confirmDialogOK() {
    switch (this.tabIndex) {
      case 0: {
        if (this.caseCd.value.length == 0 || this.caseCd.invalid) {
          this.caseCd.enable();
          this.caseCdElement.nativeElement.select();
        } else this.onTabConfirmDialogOkButtonClick();
        break;
      }
      case 1: {
        this.onTab2ConfirmDialogOkButtonClick();
        break;
      }
    }
    this.isShowConfirmDialog = false;
  }

  onChangeCaseCd(event: any) {
    this.clearLog();

    if (event.target.value.trim() === '') {
      return;
    }
    this.caseCd.markAsTouched();
    if (this.caseCd.invalid) {
      return;
    }
    const jsonUnit: object = {
      caseCd: event.target.value.trim().toUpperCase()
    };
    this.caseList.push(jsonUnit);
    this.isCaseEnterd = true;
    //SW-1894
    this.isSubmitButtonEnabled = this.tabIndex == 0 ? this.picknoCd.value.length > 0 && this.isCaseEnterd == true : this.picknoCd.value.length > 0;
    let log1Tx;
    for (var i = 0; i < this.caseList.length; i++) {
      log1Tx = 'ケースコード: ' + this.caseList[i]['caseCd'];
    }
    this.insertLog(moment(new Date()).format('HH:mm:ss'), log1Tx, false, this.secondInputFlag);
    this.caseCdElement.nativeElement.select();
  }

  executeTab1() {
    this.working = true;
    this.isSubmitButtonEnabled = false;
    // 納品書初回出力
    console.log(this.caseList);
    this.shipInvoiceService
      .printByPick(this.printagentCd, '', this.picknoCd.value.toUpperCase(), null, 1, 'wa3051')
      .then(outputJson => {
        console.log(outputJson);
        //印刷された場合のみファイル取得
        if(outputJson.printinvoiceNr > 0){
          //CreateForm帳票ファイル取得
          this.getFile(outputJson.reportCd, outputJson.jobId, outputJson.reporttrnId);
        }

        // 納品書出力が正常に完了
        this.insertLog(moment(new Date()).format('HH:mm:ss'), 'ピック番号=[' + this.picknoCd.value + '] 納品書出力枚数=[' + outputJson.printinvoiceNr + ']', false, this.firstInputFlag);
        //荷札出力する
        this.shipDeliService
          .printByOrder(
            this.printagentCd,
            '',
            this.picknoCd.value.toUpperCase(),
            this.caseList,
            "wa3051"
          )
          .then(outputJson => {
            //荷札出力はポーリングにより出力するのでメッセージ表示のみ

            // 荷札出力が正常に完了
            this.insertLog(
              moment(new Date()).format('HH:mm:ss'),
              'ピック番号=[' + this.picknoCd.value + '] 荷札出力枚数=[' + outputJson.printdeliNr + ']',
              false,
              this.firstInputFlag
            );
            this.initPicknoCd();
            this.initCaseCd();
            this.working = false;
            this.submitButtonEnabled();
            this.picknoCdElement.nativeElement.focus();
          })
          .catch(error => {
            // 荷札出力がエラー
            console.log(this.commonService.getErrorMessage(error));

            this.insertLog(null, this.commonService.getErrorMessage(error), true, null);
            this.insertLog(
              moment(new Date()).format('HH:mm:ss'),
              'ピック番号=[' + this.picknoCd.value + ']',
              false,
              this.firstInputFlag
            );
            this.isRePrint = false;
            this.picknoCd.enable();
            this.initCaseCd();
            this.working = false;
            this.submitButtonEnabled();
            this.picknoCdElement.nativeElement.select();
          })
      })
      .catch(error => {
        // 納品書出力がエラー
        console.log(this.commonService.getErrorMessage(error));
        if (this.commonService.getErrorMessage(error))
          this.insertLog(null, this.commonService.getErrorMessage(error), true, null);
        this.insertLog(moment(new Date()).format('HH:mm:ss'), 'ピック番号=[' + this.picknoCd.value + ']', false, this.firstInputFlag);

        this.isRePrint = false;
        this.picknoCd.enable();
        this.initCaseCd();
        this.caseCd.enable();
        this.working = false;
        this.submitButtonEnabled();
        this.picknoCdElement.nativeElement.select();
      });
  }

  executeTab2() {
    // 二重入力を防ぐため入力欄を無効化
    this.picknoCd.disable();
    this.working = true;
    this.isSubmitButtonEnabled = false;

    // バリデーション
    // picknoCdの最初の文字がP 且つ "-"が1つまたは2つ含まれていない 場合
    let splitedVal = this.picknoCd.value.toUpperCase().split('-');
    if (!this.picknoCd.value.toUpperCase().startsWith('P') 
         || !(splitedVal.length == 2 || splitedVal.length == 3)) {
      this.insertLog('', 'ピック番号またはケースピック番号を入力してください。', false, null);
      this.picknoCd.enable();
      this.working = false;
      this.picknoCdElement.nativeElement.select();
      return;
    }
    this.picknoCd.markAsTouched();
    if (this.picknoCd.invalid) {
      this.picknoCd.enable();
      this.working = false;
      this.submitButtonEnabled();
      this.picknoCdElement.nativeElement.select();
      return;
    }
    // 前回ログ削除
    this.clearLog();
    // 納品書出力
    let picknoCd = splitedVal[0] + '-' + splitedVal[1];
    let pickdetnoCd = splitedVal.length==3 ? splitedVal[2] : null;
    this.shipInvoiceService
      .printByPick(this.printagentCd, '', picknoCd, pickdetnoCd, 0, 'wa3050')
      .then(outputJson => {
        console.log(outputJson);
        if (outputJson.printedFl === 0) {
          if(outputJson.printinvoiceNr > 0){
            //CreateForm帳票ファイル取得
            this.getFile(outputJson.reportCd, outputJson.jobId, outputJson.reporttrnId);
          }

          // 納品書出力が正常に完了
          this.insertLog(
            moment(new Date()).format('HH:mm:ss'),
            'ピック番号=[' + this.picknoCd.value + '] 納品書出力枚数=[' + outputJson.printinvoiceNr + ']',
            false,
            this.firstInputFlag
          );
          // 荷札初回出力
          this.shipDeliService
            .printByPick(
              this.printagentCd
              , ''
              , picknoCd
              , pickdetnoCd
              , 0
              , 'wa3050')
            .then(outputJson => {
              //荷札出力はポーリングにより出力するのでメッセージ表示のみ

              // 荷札初回出力が正常に完了
              this.insertLog(
                moment(new Date()).format('HH:mm:ss'),
                'ピック番号=[' + this.picknoCd.value + '] 荷札出力枚数=[' + this.sumPrintdeliNr(outputJson) + ']',
                false,
                this.firstInputFlag
              );
                
                
                
              this.picknoCd.enable();
              this.working = false;
              this.submitButtonEnabled();
              this.picknoCdElement.nativeElement.select();
            })
            .catch(error => {
              // 荷札書出力がエラー
              console.log(this.commonService.getErrorMessage(error));
              this.insertLog(null, this.commonService.getErrorMessage(error), true, null);
              this.insertLog(moment(new Date()).format('HH:mm:ss'), ' ピック番号=[' + this.picknoCd.value + ']', false, this.firstInputFlag);
              this.picknoCd.enable();
              this.working = false;
              this.submitButtonEnabled();
              this.picknoCdElement.nativeElement.select();
            });
        } else {
          // 納品書出力済みの場合
          if (!this.disableF999) {
            // 再出力不可
            this.insertLog(moment(new Date()).format('HH:mm:ss'), 'ピック番号=[' + this.picknoCd.value + ']', false, this.firstInputFlag);
            this.insertLog('', '出力済みです（権限不足のため再出力できません）。', false, null);
            this.picknoCd.enable();
            this.working = false;
            this.submitButtonEnabled();
            this.picknoCdElement.nativeElement.select();
          } else {
            // 再出力可
            this.isShowConfirmDialog = true;
          }
        }
      })
      .catch(error => {
        // 納品書初回出力がエラー
        console.log(this.commonService.getErrorMessage(error));
        if (this.commonService.getErrorMessage(error)) this.insertLog(null, this.commonService.getErrorMessage(error), true, null);
        this.insertLog(moment(new Date()).format('HH:mm:ss'), 'ピック番号=[' + this.picknoCd.value + ']', false, this.firstInputFlag);
        this.picknoCd.enable();
        this.working = false;
        this.submitButtonEnabled();
        this.picknoCdElement.nativeElement.focus();
        this.picknoCdElement.nativeElement.select();
      });
  }

  sumPrintdeliNr(outputJson) {
    let totalNr = 0;
    for (let i = 0; i < outputJson.length; i++) {
      totalNr += outputJson[i].printdeliNr;
    }
    return totalNr;
  }

  onTabConfirmDialogCancelButtonClick() {
    this.picknoCd.enable();
    this.initCaseCd();
    this.caseCd.disable();
    this.working = false;
    this.submitButtonEnabled();
    this.picknoCdElement.nativeElement.select();
  }

  onTabConfirmDialogOkButtonClick() {
    // this.executeTab1();
    // 荷札を再出力する
    this.initCaseCd();
    this.caseCd.enable();
    this.working = false;
    this.caseCdElement.nativeElement.focus();
  }

  onTab2ConfirmDialogOkButtonClick() {
    this.working = true;
    let splitedVal = this.picknoCd.value.toUpperCase().split('-');
    let picknoCd = splitedVal[0] + '-' + splitedVal[1];
    let pickdetnoCd = splitedVal.length==3 ? splitedVal[2] : null;
    this.shipInvoiceService
      .printByPick(this.printagentCd, '', picknoCd, pickdetnoCd, 1, 'wa3050')
      .then(outputJson => {
        //印刷がされた場合のみファイル取得
        if(outputJson.printinvoiceNr > 0){
          //CreateForm帳票ファイル取得
          this.getFile(outputJson.reportCd, outputJson.jobId, outputJson.reporttrnId);
        }

        // 納品書出力が正常に完了
        this.insertLog(moment(new Date()).format('HH:mm:ss'), 'ピック番号=[' + this.picknoCd.value + '] 納品書出力枚数=[' + outputJson.printinvoiceNr + ']', false, this.firstInputFlag);

        // 荷札出力
        this.shipDeliService
          .printByPick(
            this.printagentCd,
            '',
            picknoCd,
            pickdetnoCd,
            1,
            "wa3050"
          )
          .then(outputJson => {
            //荷札出力はポーリングにより出力するのでメッセージ表示のみ

            // 荷札再出力が正常に完了
            this.insertLog(moment(new Date()).format('HH:mm:ss'), 'ピック番号=[' + this.picknoCd.value + '] 荷札出力枚数=[' + this.sumPrintdeliNr(outputJson) + ']', false, this.firstInputFlag);
            this.picknoCd.enable();
            this.working = false;
            this.picknoCdElement.nativeElement.select();
          })
          .catch(error => {
            // 荷札再出力がエラー
            console.log(this.commonService.getErrorMessage(error));
            this.insertLog(null, this.commonService.getErrorMessage(error), true, null);
            this.insertLog(moment(new Date()).format('HH:mm:ss'), 'ピック番号=[' + this.picknoCd.value + ']', false, this.firstInputFlag);
            this.picknoCd.enable();
            this.working = false;
            this.picknoCdElement.nativeElement.select();
          })
      })
      .catch(error => {
        // 納品書再出力がエラー
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.insertLog(null, this.commonService.getErrorMessage(error), true, null);
        this.insertLog(moment(new Date()).format('HH:mm:ss'), 'ピック番号=[' + this.picknoCd.value + ']', false, this.firstInputFlag);

        this.picknoCd.enable();
        this.working = false;
        this.picknoCdElement.nativeElement.select();
      });
  }

  onTab2ConfirmDialogCancelButtonClick() {
    // 納品書を再出力しない
    this.picknoCd.enable();
    this.working = false;
    this.picknoCdElement.nativeElement.select();
  }

  clear() {
    this.clearLog();
    this.initPicknoCd();
    this.initCaseCd();
    this.caseCd.enable();
    this.working = false;
    this.picknoCdElement.nativeElement.focus();
  }

  initPicknoCd() {
    this.isRePrint = false;
    this.picknoCd.enable();
    this.picknoCd.setValue('');
    this.picknoCd.markAsUntouched();
  }

  initCaseCd() {
    this.caseCd.disable();
    this.caseCd.setValue('');
    this.caseList = [];
    this.isCaseEnterd = false;
    this.caseCd.markAsUntouched();
  }

  clearLog() {
    this.working = false;
  }

  changeTab(index) {
    this.tabIndex = index;
    this.picknoCdElement.nativeElement.focus();
  }

  clearInput(event) {
    event.stopPropagation();

    var _logArea = this.tabIndex == 0 ? this.logArea : this.logArea2;
    this.picknoCd.setValue('');
    this.caseCd.setValue('');
    this.picknoCd.enable();
    this.caseCd.disable();
    //SW-1894
    this.isCaseEnterd = false;
    this.picknoCdElement.nativeElement.select();
    _logArea.nativeElement.innerHTML = '';
  }

  insertLog(time, logStr, isError, inputFlag) {
    var _logArea = this.tabIndex == 0 ? this.logArea : this.logArea2;

    if (isError) {
      _logArea.nativeElement.insertAdjacentHTML('afterbegin', '<p class="red-line" style="font-size: 18px;color: #D93B3B;margin-left: 87px;">' + logStr + '</p>');
    } else {
      let html = '<p class="err-line" style="margin-top: 10px;font-size: 20px;font-weight: bold;line-height: 1.4em;">';
      if (time != null) html += '<span style="font-weight: normal;">' + time + '</span>';
      html += '&nbsp;&nbsp;' + logStr + '</p>';
      _logArea.nativeElement.insertAdjacentHTML('afterbegin', html);
    }
  }

  tab1Dispatcher() {
    if (this.picknoCd.value.length == 0 || this.picknoCd.invalid) {
      this.working = false;
      this.picknoCd.enable();
      this.picknoCdElement.nativeElement.select();
      return;
    }

    this.executeTab1();
  }

  checkOrder() {
    this.clearLog();

    // 二重入力を防ぐため入力欄を無効化
    this.picknoCd.disable();
    this.working = true;
    // バリデーション
    this.picknoCd.markAsTouched();
    if (this.picknoCd.invalid) {
      this.picknoCd.enable();
      this.working = false;
      this.picknoCdElement.nativeElement.select();
      return;
    }
    //this.executeTab1();

    const picknoRegex = /^P\d{8}-\d{5}$/;
    const pickCaseRegex = /^P\d{8}-\d{5}-C-\d+$/;
    if (!picknoRegex.test(this.picknoCd.value.toUpperCase()) && !pickCaseRegex.test(this.picknoCd.value.toUpperCase())) {
      this.insertLog('', 'ピック番号、または梱包番号を入力してください。', false, null);
      this.picknoCd.enable();
      this.working = false;
      this.picknoCdElement.nativeElement.select();
      return;
    }

    // 前回ログ削除
    this.clearLog();
    // 荷札初回出力
    this.shipDeliService
      .checkByOrder(this.picknoCd.value.toUpperCase(), 'wa3051')
      .then(outputJson => {
        console.log(outputJson);
        if (outputJson.printedFl === 0) {
          // 出力済みでない場合
          this.isRePrint = false;
          this.initCaseCd();
          this.caseCd.enable();
          this.working = false;
          this.caseCdElement.nativeElement.select();
        } else {
          // 出力済みの場合
          this.isRePrint = true;
          if (!this.disableF999) {
            // 再出力不可
            this.insertLog(moment(new Date()).format('HH:mm:ss'), 'ピック番号=[' + this.picknoCd.value + ']', false, this.firstInputFlag);
            this.insertLog('', '出力済みです（権限不足のため再出力できません）。', false, null);

            this.picknoCd.enable();
            this.initCaseCd();
            this.caseCd.enable();
            this.working = false;
            this.picknoCdElement.nativeElement.select();
          } else {
            console.log(this.executeButton);
            // 再出力可
            this.isShowConfirmDialog = true;
          }
        }
      })
      .catch(error => {
        // チェックエラー
        console.log(this.commonService.getErrorMessage(error));

        this.insertLog(null, this.commonService.getErrorMessage(error), true, null);
        this.insertLog(moment(new Date()).format('HH:mm:ss'), 'ピック番号=[' + this.picknoCd.value + ']', false, this.firstInputFlag);

        this.isRePrint = false;
        this.picknoCd.enable();
        this.initCaseCd();
        this.working = false;
        this.picknoCdElement.nativeElement.select();
      });
  }

  execute() {
    if (this.tabIndex == 0) this.tab1Dispatcher();
    else this.executeTab2();
  }

  submitButtonEnabled() {
    this.isSubmitButtonEnabled = this.tabIndex == 0 ? this.picknoCd.value.length > 0 && this.isCaseEnterd == true : this.picknoCd.value.length > 0;
  }
  
  close3051() {
    window.close();
  }

  //CreateForm帳票ファイル取得呼び出し（クライアント印刷）
  getFile(reportCd, jobId, reporttrnId) {

    //クエリ文字列の生成
    cwebclient.FormRequestArray = getCreateFormRequest(JSON.parse(sessionStorage.getItem('loginResult'))['sessionKey'], jobId, reportCd, reporttrnId, '');
    //帳票印刷APIのURL
    cwebclient.CreatePrintingDataScriptUrl = this.createFormService.getReportUrl();
    // 帳票コードを引数に指定
    cwebclient.PrintExecuteEx(reportCd);  
        
  }

  //*-- 印刷ポーリング後処理 --*//
  //印刷キューチェック成功
  checkPrintQueueSuccess(json){
    //未印刷が存在する場合
    if(json.clientreportResponseRecordList.length > 0){
      for (var i = 0; i < json.clientreportResponseRecordList.length; i++) {
        var outputJson = json.clientreportResponseRecordList[i];
        this.getFile(outputJson.reportCd, outputJson.jobId, outputJson.reporttrnId);
      }
    }
  }  
  //印刷キューチェック失敗
  checkPrintQueueError(error){
    //ポーリング停止
    if(this.data$){
      this.data$.unsubscribe();
    }
    //アラートダイアログを表示
    console.log(this.commonService.getErrorMessage(error));
    this.dialogsService.info('クライアント印刷エラー', this.commonService.getErrorMessage(error));
  }    

  onGlobalEnterKeyup() {
    // if (this.isShowConfirmDialog) this.confirmDialogOK();
  }

  /* JSでフルスクリーン機能を追加。TSに変換出来次第実装したい。
  openFullscreen() {
    const element: HTMLInputElement =<HTMLInputElement>document.getElementById(‘fullscreen');
    const value: string = element.value;
    document.fullScreenElement && null !== document.fullScreenElement || !document.mozFullScreen && !document.webkitIsFullScreen ? document.documentElement.requestFullScreen ? document.documentElement.requestFullScreen() : document.documentElement.mozRequestFullScreen ? document.documentElement.mozRequestFullScreen() : document.documentElement.webkitRequestFullScreen && document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT) : document.cancelFullScreen ? document.cancelFullScreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen()
  }
*/
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3051/wa3051.component.ts